// MapLibre 6 ships as ES modules and finds its worker by building a URL next
// to its own file at runtime. A bundler cannot see that, so in a Vite build
// (and behind Vite's dev pre-bundling) the worker 404s and the map stays
// blank. Bundle the worker ourselves and hand MapLibre the URL. Import this
// module for its side effect from every file that creates a map.
import { setWorkerUrl } from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

setWorkerUrl(workerUrl);
